import { styled } from "react-alicerce-components";

export const Container = styled.div``

export const List = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1rem;
`